import { render, staticRenderFns } from "./addCardNumber.vue?vue&type=template&id=24728f95&scoped=true"
import script from "./addCardNumber.vue?vue&type=script&lang=js"
export * from "./addCardNumber.vue?vue&type=script&lang=js"
import style0 from "./addCardNumber.vue?vue&type=style&index=0&id=24728f95&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24728f95",
  null
  
)

export default component.exports